import * as ga4 from '@animaweb-js/components/ga4';

window.addEventListener('load', (event) => {
    //
    // ga4 et marketing
    //
    ga4.addGtagOnConsent(function () {})
});